import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default function useTourLocale() {
    const { t, i18n } = useTranslation('tour')

    // `nextWithProgress` keeps react-joyride's single-brace {step}/{steps} tokens
    // (replaced by the library, NOT by i18next which only touches {{ }}).
    const joyrideLocale = useMemo(() => ({
        back: t('tour:controls.back'),
        close: t('tour:controls.close'),
        last: t('tour:controls.last'),
        next: t('tour:controls.next'),
        skip: t('tour:controls.skip'),
        nextLabelWithProgress: t('tour:controls.nextWithProgress'),
    }), [t, i18n.language])

    return { joyrideLocale }
}
